// CustomToolbarWithSearch.js
import React, { useRef } from "react";
import { GridToolbarContainer, useGridApiContext } from "@mui/x-data-grid";
import {
  Box,
  TextField,
  IconButton,
  Tooltip,
  InputAdornment,
  Badge,
} from "@mui/material";
import {
  ViewColumnRounded,
  DensityMediumRounded,
  DownloadRounded,
  SearchRounded,
  FilterListRounded,
} from "@mui/icons-material";

export const CustomToolbarWithSearch = () => {
  const apiRef = useGridApiContext();

  const handleDensityClick = () => {
    const currentDensity = apiRef.current.state.density;
    const densities = ["compact", "standard", "comfortable"];
    const nextIndex =
      (densities.indexOf(currentDensity) + 1) % densities.length;
    apiRef.current.setDensity(densities[nextIndex]);
  };

  return (
    <GridToolbarContainer
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1,
      }}
    >
      {/* Toolbar Actions */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title="Show / Hide Columns" arrow>
          <IconButton
            size="small"
            onClick={() => {
              apiRef.current.showPreferences("columns");
            }}
          >
            <ViewColumnRounded
              fontSize="small"
              sx={{ color: "primary.main" }}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title="Change Density" arrow>
          <IconButton
            size="small"
            onClick={() => {
              handleDensityClick();
            }}
          >
            <DensityMediumRounded
              fontSize="small"
              sx={{ color: "primary.main" }}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title="Export" arrow>
          <IconButton
            size="small"
            onClick={() => {
              apiRef.current.exportDataAsCsv();
            }}
          >
            <DownloadRounded fontSize="small" sx={{ color: "primary.main" }} />
          </IconButton>
        </Tooltip>
      </Box>
    </GridToolbarContainer>
  );
};
